/* eslint-disable */
import CodeMirror from 'codemirror'
import _ from 'lodash'

(function (mod) {
  if (typeof exports === 'object' && typeof module === 'object') { // CommonJS
    mod(require('codemirror'))
  } else if (typeof define === 'function' && define.amd) { // AMD
    define(['codemirror'], mod)
  } else { // Plain browser env
    mod(CodeMirror)
  }
})(_.debounce( CodeMirror => {
  'use strict'
  // declared global: SQLLint
  const validator = function (text, options) {
    if (!window.SQLLint) {
      if (window.console) {
        window.console.error('Error: window.SQLLint not defined, CodeMirror SQL linting cannot run.')
      }
      return []
    }
    if (!options.indent) { // JSHint error.character actually is a column index, this fixes underlining on lines using tabs for indentation
      options.indent = 1 // JSHint default value is 4
    }
    const lintObj = new SQLLint(text)
    const messages = lintObj.lintCheck()

    const result = []
    if (messages.length) {
      parseErrors(messages, result)
    }
    return result
  }

  CodeMirror.registerHelper('lint', 'sql', validator)

  function parseErrors (errors, output) {
    errors.forEach(error => {
      if (error) {
        if (error.line <= 0) {
          if (window.console) {
            window.console.warn('Cannot display SQLLint error (invalid line ' + error.line + ')', error)
          }
          return
        }
        // Convert to format expected by validation service
        const hint = {
          message: error.content,
          severity: error.messageType,
          from: CodeMirror.Pos(error.line - 1, error.offset.start),
          to: CodeMirror.Pos(error.line - 1, error.offset.end)
        }
        output.push(hint)
      }
    }) 
  }
}), 1000)

window.SQLLint = require('./sqlLint').SQLLint
